export default __webpack_public_path__ + "static/media/resultados_prueba.ef6d3ead.pdf";